import type { PropsWithChildren } from 'react'
import { useNavigate } from 'react-router-dom'

import { Page as DhlPage, type PageMenuItem } from '@dhl-ui/page'
import { Page as ReceiverPage, type PageProps } from '@dhl/receiver-page'
import { useIsMobileVariant } from '@dhl-ui/components'

import { DocumentTitle } from '@dhl/receiver-a11y'
import { HeaderContent } from './HeaderContent'
import { useMenuItems } from './use-menu-items'
import { EndNode } from './EndNode'

type Props = PropsWithChildren<PageProps> & {
  /**
   * @default false
   */
  hideBottomMenu?: boolean
}

export const Page = ({ isLoading = false, children, title, hideBottomMenu = false, ...props }: Props) => {
  const navigate = useNavigate()
  const isMobileVariant = useIsMobileVariant()
  const menuItems = useMenuItems()

  const handleMenuSelect = (item: PageMenuItem) => {
    navigate(item.link)
  }

  return (
    <ReceiverPage
      sideMenu={
        isMobileVariant ? undefined : (
          <DhlPage.SideMenu items={menuItems} onSelect={handleMenuSelect} endNode={<EndNode />} />
        )
      }
      bottomMenu={
        isMobileVariant && !hideBottomMenu ? (
          <DhlPage.BottomMenu items={menuItems} onSelect={handleMenuSelect} />
        ) : undefined
      }
      header={<DhlPage.Header endNode={<HeaderContent />} />}
      isLoading={isLoading}
      {...props}
    >
      <DocumentTitle title={title} />
      {children}
    </ReceiverPage>
  )
}
